<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-main">
        <RentCreateUpdate :formName="panel.formName" />
      </div>
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>

import ViewTemplateWithSalveCancel from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithSalveCancel";
import RentCreateUpdate from "../../../components/modules/rental/rent/RentCreateUpdate.vue";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "RentCreateUpdateView",
  components: {
    ViewTemplateWithSalveCancel,
    RentCreateUpdate,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.params.type,
      panel: {
        module: "Locação",
        title: "Locação",
        formName: "rentCreateUpdate",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),

  },
};
</script>
